export const TABS = {
  MAIN: 'main',
  RESIDENCE: 'residence',
  MARITAL: 'marital',
  DEPENDANTS: 'dependants',
  DOCS: 'document_submission',
};
